import { render } from "./WaterAlerts.vue?vue&type=template&id=6eb2a8c4"
import script from "./WaterAlerts.vue?vue&type=script&lang=js"
export * from "./WaterAlerts.vue?vue&type=script&lang=js"

import "./WaterAlerts.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script